// Sales RM composer fields (To/CC/BCC) are plain text inputs that accept
// multiple comma/semicolon-separated addresses - the send pipeline needs them
// as a string[].
export const parseAddressList = (value: string): string[] =>
  value
    .split(/[,;]/)
    .map((part) => part.trim())
    .filter(Boolean);
